// Gegenereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum PlanningStatus {
    PlanningBakVanWessel = 'planningBakVanWessel',
    PlanningBevestigd = 'planningBevestigd',
    PlanningDefinitief = 'planningDefinitief',
    PlanningGeblokkeerd = 'planningGeblokkeerd',
    PlanningGepland = 'planningGepland',
    PlanningReservering = 'planningReservering',
    PlanningSlaapdag = 'planningSlaapdag',
}
